export const name = 'editorNavigation' as const
export const EditorNavigationSymbol = Symbol('editorNavigationSymbol')
